import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

const HeroSection = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const scrollToServices = () => {
    const el = document.getElementById('nos-services');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/0ee27b0edef2e8137e2eac1e67b920ac.jpeg"
          alt="Décoration haut de gamme Abidjan"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/65" />
      </div>

      {/* Content */}
      <div className={`relative z-10 w-full text-center px-6 max-w-5xl mx-auto transition-all duration-1000 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        {/* Label */}
        <div className="inline-flex items-center gap-2 mb-6">
          <span className="h-px w-8 bg-brand-gold" />
          <span className="text-brand-gold text-xs font-medium tracking-[0.2em] uppercase">Abidjan, Côte d'Ivoire</span>
          <span className="h-px w-8 bg-brand-gold" />
        </div>

        {/* Main headline */}
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-6">
          Décoration haut de gamme pour{' '}
          <em className="text-brand-coral not-italic">particuliers et entreprises</em>{' '}
          à Abidjan
        </h1>

        {/* Subtext */}
        <p className="text-white/85 text-lg md:text-xl max-w-3xl mx-auto leading-relaxed mb-10 font-light">
          Depuis 2019, Ev&amp;Co accompagne particuliers et entreprises dans la création d'espaces et d'événements à leur image.
          De la décoration à la conception 3D, nous donnons vie à vos idées avec <em>créativité, rigueur et cœur.</em>
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact#contact-form"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full text-white font-medium text-sm whitespace-nowrap transition-all duration-300 hover:scale-105 hover:shadow-lg"
            style={{ background: 'linear-gradient(135deg, #e63e8b, #f78b49)' }}
          >
            <i className="ri-mail-send-line" />
            Demander un devis
          </Link>
          <button
            onClick={scrollToServices}
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-white/60 text-white font-medium text-sm whitespace-nowrap transition-all duration-300 hover:bg-white/10 cursor-pointer"
          >
            <i className="ri-arrow-right-line" />
            Découvrir nos services
          </button>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white/50 text-xs tracking-widest uppercase">Défiler</span>
          <i className="ri-arrow-down-line text-white/50 text-lg" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
